import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c4d87c34"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "docDesigner"
};
const _hoisted_2 = {
  class: "toolPanel"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "menuBtn"
}, "文件", -1));
const _hoisted_4 = /*#__PURE__*/_createTextVNode("打开本地文件");
const _hoisted_5 = /*#__PURE__*/_createTextVNode("保存");
const _hoisted_6 = /*#__PURE__*/_createTextVNode("页面设置");
const _hoisted_7 = /*#__PURE__*/_createTextVNode("打印");
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "menuBtn"
}, "下载", -1));
const _hoisted_9 = /*#__PURE__*/_createTextVNode("RTF");
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "menuBtn"
}, "编辑", -1));
const _hoisted_11 = /*#__PURE__*/_createTextVNode("撤销");
const _hoisted_12 = /*#__PURE__*/_createTextVNode("重做");
const _hoisted_13 = /*#__PURE__*/_createTextVNode("剪切");
const _hoisted_14 = /*#__PURE__*/_createTextVNode("复制");
const _hoisted_15 = /*#__PURE__*/_createTextVNode("粘贴");
const _hoisted_16 = /*#__PURE__*/_createTextVNode("粘贴为文本");
const _hoisted_17 = /*#__PURE__*/_createTextVNode("全选");
const _hoisted_18 = /*#__PURE__*/_createTextVNode("格式刷");
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "menuBtn"
}, "插入", -1));
const _hoisted_20 = /*#__PURE__*/_createTextVNode("插入图片");
const _hoisted_21 = /*#__PURE__*/_createTextVNode("插入单复选框");
const _hoisted_22 = /*#__PURE__*/_createTextVNode("插入分割线");
const _hoisted_23 = /*#__PURE__*/_createTextVNode("插入页码");
const _hoisted_24 = /*#__PURE__*/_createTextVNode("插入分页符");
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "menuBtn"
}, "格式", -1));
const _hoisted_26 = /*#__PURE__*/_createTextVNode("清除格式");
const _hoisted_27 = /*#__PURE__*/_createTextVNode("段落");
const _hoisted_28 = /*#__PURE__*/_createTextVNode("数字列表");
const _hoisted_29 = /*#__PURE__*/_createTextVNode("圆点列表");
const _hoisted_30 = /*#__PURE__*/_createTextVNode("粗体");
const _hoisted_31 = /*#__PURE__*/_createTextVNode("斜体");
const _hoisted_32 = /*#__PURE__*/_createTextVNode("下划线");
const _hoisted_33 = /*#__PURE__*/_createTextVNode("删除线");
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "menuBtn"
}, "表格", -1));
const _hoisted_35 = /*#__PURE__*/_createTextVNode("插入表格");
const _hoisted_36 = /*#__PURE__*/_createTextVNode("删除表格");
const _hoisted_37 = /*#__PURE__*/_createTextVNode("对齐方式");
const _hoisted_38 = /*#__PURE__*/_createTextVNode("在上面插入表格行");
const _hoisted_39 = /*#__PURE__*/_createTextVNode("在下面插入表格行");
const _hoisted_40 = /*#__PURE__*/_createTextVNode("删除表格行");
const _hoisted_41 = /*#__PURE__*/_createTextVNode("在左侧插入表格列");
const _hoisted_42 = /*#__PURE__*/_createTextVNode("在右侧插入表格列");
const _hoisted_43 = /*#__PURE__*/_createTextVNode("删除表格列");
const _hoisted_44 = /*#__PURE__*/_createTextVNode("合并单元格");
const _hoisted_45 = /*#__PURE__*/_createTextVNode("拆分单元格");
const _hoisted_46 = {
  class: "toolDiv"
};
const _hoisted_47 = {
  class: "tool-box"
};
const _hoisted_48 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h-divide"
}, null, -1));
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h-divide"
}, null, -1));
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h-divide"
}, null, -1));
const _hoisted_51 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h-divide"
}, null, -1));
const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h-divide"
}, null, -1));
const _hoisted_53 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "myWriterControl",
  class: "myWriterCss",
  dctype: "WriterControlForWASM",
  RuleVisible: "true",
  AllowDrop: "true",
  AllowDragContent: "true",
  RuleBackColor: "rgb(155, 187, 227)",
  CaretCss: "3,Blue",
  RegisterCode: "04023D6AB58E2F0368E2CB1293E20AEC7E45710588485AFAE01F92A6136F90A67BBF0984254D49C785382FCD14A5BC85E925F0CBA3D2AAF81A1A3C347C1A9D1D15DDBA5D2A849AF3A8A7B8D9EC6D4E5A66",
  PageCssString: "box-shadow:0px 0px 0px grey",
  ServicePageUrl: "http://www.dcwriter.cn:8044/dcwritersvp"
}, "正在加载...", -1));
const _hoisted_54 = {
  class: "align-box"
};
const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "align-icon-block"
}, null, -1));
const _hoisted_56 = [_hoisted_55];
const _hoisted_57 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "align-icon-block"
}, null, -1));
const _hoisted_58 = [_hoisted_57];
const _hoisted_59 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "align-icon-block"
}, null, -1));
const _hoisted_60 = [_hoisted_59];
const _hoisted_61 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "align-icon-block"
}, null, -1));
const _hoisted_62 = [_hoisted_61];
const _hoisted_63 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "align-icon-block"
}, null, -1));
const _hoisted_64 = [_hoisted_63];
const _hoisted_65 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "align-icon-block"
}, null, -1));
const _hoisted_66 = [_hoisted_65];
const _hoisted_67 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "align-icon-block"
}, null, -1));
const _hoisted_68 = [_hoisted_67];
const _hoisted_69 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "align-icon-block"
}, null, -1));
const _hoisted_70 = [_hoisted_69];
const _hoisted_71 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "align-icon-block"
}, null, -1));
const _hoisted_72 = [_hoisted_71];
const _hoisted_73 = {
  style: {
    "width": "100%",
    "max-height": "350px",
    "overflow-y": "auto"
  }
};
const _hoisted_74 = {
  class: "eidtor-field-list-box"
};
const _hoisted_75 = {
  class: "eidtor-field-list-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  const _component_IconDocBaocun = _resolveComponent("IconDocBaocun");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_IconDocJianqie = _resolveComponent("IconDocJianqie");
  const _component_IconDocFuzhi = _resolveComponent("IconDocFuzhi");
  const _component_IconDocZhantie = _resolveComponent("IconDocZhantie");
  const _component_IconDocGeshishua = _resolveComponent("IconDocGeshishua");
  const _component_IconDocShangyibu = _resolveComponent("IconDocShangyibu");
  const _component_IconDocXiayibu = _resolveComponent("IconDocXiayibu");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_IconDocZiti = _resolveComponent("IconDocZiti");
  const _component_IconDocZitijiacu = _resolveComponent("IconDocZitijiacu");
  const _component_IconDocXieti = _resolveComponent("IconDocXieti");
  const _component_IconDocXiahuaxian = _resolveComponent("IconDocXiahuaxian");
  const _component_IconDocZitiyanse = _resolveComponent("IconDocZitiyanse");
  const _component_el_color_picker = _resolveComponent("el-color-picker");
  const _component_IconDocZitibeijingse = _resolveComponent("IconDocZitibeijingse");
  const _component_IconDocZitishangbiao = _resolveComponent("IconDocZitishangbiao");
  const _component_IconDocZitixiabiao = _resolveComponent("IconDocZitixiabiao");
  const _component_IconDocZuoduiqi = _resolveComponent("IconDocZuoduiqi");
  const _component_IconDocJuzhongduiqi = _resolveComponent("IconDocJuzhongduiqi");
  const _component_IconDocYouduiqi = _resolveComponent("IconDocYouduiqi");
  const _component_IconDocZuoyouduiqi = _resolveComponent("IconDocZuoyouduiqi");
  const _component_IconDocYouxupailie = _resolveComponent("IconDocYouxupailie");
  const _component_IconDocWuxupailie = _resolveComponent("IconDocWuxupailie");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  const _component_el_dialog_sec = _resolveComponent("el-dialog-sec");
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_scrollbar, null, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_dropdown, {
      trigger: "click",
      size: "small",
      onCommand: $options.commandHandler
    }, {
      dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
        default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
          command: "FileOpen"
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), _createVNode(_component_el_dropdown_item, {
          command: "Save"
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        }), _createVNode(_component_el_dropdown_item, {
          divided: "",
          command: "pageSet"
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        }), _createVNode(_component_el_dropdown_item, {
          command: $data.writerState.printpreview ? 'closeprintpreview' : 'printpreview'
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($data.writerState.printpreview ? '结束打印预览' : '打印预览'), 1)]),
          _: 1
        }, 8, ["command"]), _createVNode(_component_el_dropdown_item, {
          command: "print"
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 1
        })]),
        _: 1
      })]),
      default: _withCtx(() => [_hoisted_3]),
      _: 1
    }, 8, ["onCommand"]), _createVNode(_component_el_dropdown, {
      trigger: "click",
      size: "small",
      onCommand: $options.commandHandler
    }, {
      dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
        default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
          command: "word"
        }, {
          default: _withCtx(() => [_hoisted_9]),
          _: 1
        })]),
        _: 1
      })]),
      default: _withCtx(() => [_hoisted_8]),
      _: 1
    }, 8, ["onCommand"]), _createVNode(_component_el_dropdown, {
      trigger: "click",
      size: "small",
      onCommand: $options.commandHandler
    }, {
      dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
        default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
          command: "Undo"
        }, {
          default: _withCtx(() => [_hoisted_11]),
          _: 1
        }), _createVNode(_component_el_dropdown_item, {
          command: "Redo"
        }, {
          default: _withCtx(() => [_hoisted_12]),
          _: 1
        }), _createVNode(_component_el_dropdown_item, {
          divided: "",
          command: "Cut"
        }, {
          default: _withCtx(() => [_hoisted_13]),
          _: 1
        }), _createVNode(_component_el_dropdown_item, {
          command: "Copy"
        }, {
          default: _withCtx(() => [_hoisted_14]),
          _: 1
        }), _createVNode(_component_el_dropdown_item, {
          command: "Paste"
        }, {
          default: _withCtx(() => [_hoisted_15]),
          _: 1
        }), _createVNode(_component_el_dropdown_item, {
          command: "PasteAsText"
        }, {
          default: _withCtx(() => [_hoisted_16]),
          _: 1
        }), _createVNode(_component_el_dropdown_item, {
          divided: "",
          command: "SelectAll"
        }, {
          default: _withCtx(() => [_hoisted_17]),
          _: 1
        }), _createVNode(_component_el_dropdown_item, {
          command: "FormatBrush"
        }, {
          default: _withCtx(() => [_hoisted_18]),
          _: 1
        })]),
        _: 1
      })]),
      default: _withCtx(() => [_hoisted_10]),
      _: 1
    }, 8, ["onCommand"]), _createVNode(_component_el_dropdown, {
      trigger: "click",
      size: "small",
      onCommand: $options.commandHandler
    }, {
      dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
        default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
          command: "InsertImage"
        }, {
          default: _withCtx(() => [_hoisted_20]),
          _: 1
        }), _createVNode(_component_el_dropdown_item, {
          command: "InsertCheckBoxOrRadio"
        }, {
          default: _withCtx(() => [_hoisted_21]),
          _: 1
        }), _createVNode(_component_el_dropdown_item, {
          command: "InsertHorizontalLine"
        }, {
          default: _withCtx(() => [_hoisted_22]),
          _: 1
        }), _createVNode(_component_el_dropdown_item, {
          divided: "",
          command: "InsertPageInfo"
        }, {
          default: _withCtx(() => [_hoisted_23]),
          _: 1
        }), _createVNode(_component_el_dropdown_item, {
          command: "InsertPageBreak"
        }, {
          default: _withCtx(() => [_hoisted_24]),
          _: 1
        })]),
        _: 1
      })]),
      default: _withCtx(() => [_hoisted_19]),
      _: 1
    }, 8, ["onCommand"]), _createVNode(_component_el_dropdown, {
      trigger: "click",
      size: "small",
      onCommand: $options.commandHandler
    }, {
      dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
        default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
          command: "ClearFormat"
        }, {
          default: _withCtx(() => [_hoisted_26]),
          _: 1
        }), _createVNode(_component_el_dropdown_item, {
          command: "ParagraphFormat"
        }, {
          default: _withCtx(() => [_hoisted_27]),
          _: 1
        }), _createVNode(_component_el_dropdown_item, {
          command: "insertorderedlist"
        }, {
          default: _withCtx(() => [_hoisted_28]),
          _: 1
        }), _createVNode(_component_el_dropdown_item, {
          command: "BulletedList"
        }, {
          default: _withCtx(() => [_hoisted_29]),
          _: 1
        }), _createVNode(_component_el_dropdown_item, {
          command: "Bold"
        }, {
          default: _withCtx(() => [_hoisted_30]),
          _: 1
        }), _createVNode(_component_el_dropdown_item, {
          command: "Italic"
        }, {
          default: _withCtx(() => [_hoisted_31]),
          _: 1
        }), _createVNode(_component_el_dropdown_item, {
          command: "UnderLine"
        }, {
          default: _withCtx(() => [_hoisted_32]),
          _: 1
        }), _createVNode(_component_el_dropdown_item, {
          command: "Strikeout"
        }, {
          default: _withCtx(() => [_hoisted_33]),
          _: 1
        })]),
        _: 1
      })]),
      default: _withCtx(() => [_hoisted_25]),
      _: 1
    }, 8, ["onCommand"]), _createVNode(_component_el_dropdown, {
      trigger: "click",
      size: "small",
      onCommand: $options.commandHandler
    }, {
      dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
        default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
          command: "insertTable"
        }, {
          default: _withCtx(() => [_hoisted_35]),
          _: 1
        }), _createVNode(_component_el_dropdown_item, {
          command: "Table_DeleteTable"
        }, {
          default: _withCtx(() => [_hoisted_36]),
          _: 1
        }), _createVNode(_component_el_dropdown_item, {
          command: "AlignType"
        }, {
          default: _withCtx(() => [_hoisted_37]),
          _: 1
        }), _createVNode(_component_el_dropdown_item, {
          command: "Table_InsertRowUp"
        }, {
          default: _withCtx(() => [_hoisted_38]),
          _: 1
        }), _createVNode(_component_el_dropdown_item, {
          command: "Table_InsertRowDown"
        }, {
          default: _withCtx(() => [_hoisted_39]),
          _: 1
        }), _createVNode(_component_el_dropdown_item, {
          command: "Table_DeleteRow"
        }, {
          default: _withCtx(() => [_hoisted_40]),
          _: 1
        }), _createVNode(_component_el_dropdown_item, {
          command: "Table_InsertColumnLeft"
        }, {
          default: _withCtx(() => [_hoisted_41]),
          _: 1
        }), _createVNode(_component_el_dropdown_item, {
          command: "Table_InsertColumnRight"
        }, {
          default: _withCtx(() => [_hoisted_42]),
          _: 1
        }), _createVNode(_component_el_dropdown_item, {
          command: "Table_DeleteColumn"
        }, {
          default: _withCtx(() => [_hoisted_43]),
          _: 1
        }), _createVNode(_component_el_dropdown_item, {
          command: "Table_MergeCell"
        }, {
          default: _withCtx(() => [_hoisted_44]),
          _: 1
        }), _createVNode(_component_el_dropdown_item, {
          command: "Table_SplitCellExt"
        }, {
          default: _withCtx(() => [_hoisted_45]),
          _: 1
        })]),
        _: 1
      })]),
      default: _withCtx(() => [_hoisted_34]),
      _: 1
    }, 8, ["onCommand"])]), _createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_createVNode(_component_el_icon, {
      size: $data.toolBtn.size,
      color: $data.toolBtn.color,
      class: "tool-btn",
      title: "保存",
      onClick: _cache[0] || (_cache[0] = $event => $options.commandHandler('Save'))
    }, {
      default: _withCtx(() => [_createVNode(_component_IconDocBaocun)]),
      _: 1
    }, 8, ["size", "color"]), _hoisted_48, _createVNode(_component_el_icon, {
      size: $data.toolBtn.size,
      color: $data.toolBtn.color,
      class: "tool-btn",
      title: "剪切",
      onClick: _cache[1] || (_cache[1] = $event => $options.commandHandler('Cut'))
    }, {
      default: _withCtx(() => [_createVNode(_component_IconDocJianqie)]),
      _: 1
    }, 8, ["size", "color"]), _createVNode(_component_el_icon, {
      size: $data.toolBtn.size,
      color: $data.toolBtn.color,
      class: "tool-btn",
      title: "复制",
      onClick: _cache[2] || (_cache[2] = $event => $options.commandHandler('Copy'))
    }, {
      default: _withCtx(() => [_createVNode(_component_IconDocFuzhi)]),
      _: 1
    }, 8, ["size", "color"]), _createVNode(_component_el_icon, {
      size: $data.toolBtn.size,
      color: $data.toolBtn.color,
      class: "tool-btn",
      title: "粘贴",
      onClick: _cache[3] || (_cache[3] = $event => $options.commandHandler('Paste'))
    }, {
      default: _withCtx(() => [_createVNode(_component_IconDocZhantie)]),
      _: 1
    }, 8, ["size", "color"]), _hoisted_49, _createVNode(_component_el_icon, {
      size: $data.toolBtn.size,
      color: $data.toolBtn.color,
      class: "tool-btn",
      title: "格式刷",
      onClick: _cache[4] || (_cache[4] = $event => $options.commandHandler('FormatBrush'))
    }, {
      default: _withCtx(() => [_createVNode(_component_IconDocGeshishua)]),
      _: 1
    }, 8, ["size", "color"]), _createVNode(_component_el_icon, {
      size: $data.toolBtn.size,
      color: $data.toolBtn.color,
      class: "tool-btn",
      title: "撤销",
      onClick: _cache[5] || (_cache[5] = $event => $options.commandHandler('Undo'))
    }, {
      default: _withCtx(() => [_createVNode(_component_IconDocShangyibu)]),
      _: 1
    }, 8, ["size", "color"]), _createVNode(_component_el_icon, {
      size: $data.toolBtn.size,
      color: $data.toolBtn.color,
      class: "tool-btn",
      title: "重做",
      onClick: _cache[6] || (_cache[6] = $event => $options.commandHandler('Redo'))
    }, {
      default: _withCtx(() => [_createVNode(_component_IconDocXiayibu)]),
      _: 1
    }, 8, ["size", "color"]), _hoisted_50, _createVNode(_component_el_select, {
      modelValue: $data.fontName,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.fontName = $event),
      filterable: "",
      placeholder: "字体",
      size: "small",
      style: {
        "width": "120px"
      },
      onChange: $options.fontNameChange
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.fontList, (item, index) => {
        return _openBlock(), _createBlock(_component_el_option, {
          key: 'fonttype' + index,
          label: item.label,
          value: item.value
        }, null, 8, ["label", "value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue", "onChange"]), _createVNode(_component_el_select, {
      modelValue: $data.fontSize,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.fontSize = $event),
      filterable: "",
      placeholder: "字体大小",
      size: "small",
      style: {
        "width": "80px"
      },
      onChange: $options.fontSizeChange
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.fontSizeList, (item, index) => {
        return _openBlock(), _createBlock(_component_el_option, {
          key: 'fontSize' + index,
          label: item.label,
          value: item.value
        }, null, 8, ["label", "value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue", "onChange"]), _createVNode(_component_el_icon, {
      size: $data.toolBtn.size,
      color: $data.toolBtn.color,
      class: "tool-btn",
      title: "字体",
      onClick: _cache[9] || (_cache[9] = $event => $options.commandHandler('Font'))
    }, {
      default: _withCtx(() => [_createVNode(_component_IconDocZiti)]),
      _: 1
    }, 8, ["size", "color"]), _createVNode(_component_el_icon, {
      size: $data.toolBtn.size,
      color: $data.toolBtn.color,
      class: "tool-btn",
      title: "粗体",
      onClick: _cache[10] || (_cache[10] = $event => $options.commandHandler('Bold'))
    }, {
      default: _withCtx(() => [_createVNode(_component_IconDocZitijiacu)]),
      _: 1
    }, 8, ["size", "color"]), _createVNode(_component_el_icon, {
      size: $data.toolBtn.size,
      color: $data.toolBtn.color,
      class: "tool-btn",
      title: "斜体",
      onClick: _cache[11] || (_cache[11] = $event => $options.commandHandler('Italic'))
    }, {
      default: _withCtx(() => [_createVNode(_component_IconDocXieti)]),
      _: 1
    }, 8, ["size", "color"]), _createVNode(_component_el_icon, {
      size: $data.toolBtn.size,
      color: $data.toolBtn.color,
      class: "tool-btn",
      title: "下划线",
      onClick: _cache[12] || (_cache[12] = $event => $options.commandHandler('UnderLine'))
    }, {
      default: _withCtx(() => [_createVNode(_component_IconDocXiahuaxian)]),
      _: 1
    }, 8, ["size", "color"]), _createVNode(_component_el_icon, {
      size: $data.toolBtn.size,
      color: $data.toolBtn.color,
      class: "tool-btn",
      title: "字体颜色",
      onClick: _cache[14] || (_cache[14] = $event => $options.commandHandler('Color'))
    }, {
      default: _withCtx(() => [_createVNode(_component_IconDocZitiyanse), _createVNode(_component_el_color_picker, {
        modelValue: $data.fontColor,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.fontColor = $event),
        ref: "fontColor",
        onChange: $options.fontColorChange
      }, null, 8, ["modelValue", "onChange"])]),
      _: 1
    }, 8, ["size", "color"]), _createVNode(_component_el_icon, {
      size: $data.toolBtn.size,
      color: $data.toolBtn.color,
      class: "tool-btn",
      title: "字体背景色",
      onClick: _cache[16] || (_cache[16] = $event => $options.commandHandler('BackColor'))
    }, {
      default: _withCtx(() => [_createVNode(_component_IconDocZitibeijingse), _createVNode(_component_el_color_picker, {
        modelValue: $data.backColor,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => $data.backColor = $event),
        ref: "backColor",
        onChange: $options.backColorChange
      }, null, 8, ["modelValue", "onChange"])]),
      _: 1
    }, 8, ["size", "color"]), _createVNode(_component_el_icon, {
      size: $data.toolBtn.size,
      color: $data.toolBtn.color,
      class: "tool-btn",
      title: "上标",
      onClick: _cache[17] || (_cache[17] = $event => $options.commandHandler('Superscript'))
    }, {
      default: _withCtx(() => [_createVNode(_component_IconDocZitishangbiao)]),
      _: 1
    }, 8, ["size", "color"]), _createVNode(_component_el_icon, {
      size: $data.toolBtn.size,
      color: $data.toolBtn.color,
      class: "tool-btn",
      title: "下标",
      onClick: _cache[18] || (_cache[18] = $event => $options.commandHandler('Subscript'))
    }, {
      default: _withCtx(() => [_createVNode(_component_IconDocZitixiabiao)]),
      _: 1
    }, 8, ["size", "color"]), _hoisted_51, _createVNode(_component_el_icon, {
      size: $data.toolBtn.size,
      color: $data.toolBtn.color,
      class: "tool-btn",
      title: "左对齐",
      onClick: _cache[19] || (_cache[19] = $event => $options.commandHandler('AlignLeft'))
    }, {
      default: _withCtx(() => [_createVNode(_component_IconDocZuoduiqi)]),
      _: 1
    }, 8, ["size", "color"]), _createVNode(_component_el_icon, {
      size: $data.toolBtn.size,
      color: $data.toolBtn.color,
      class: "tool-btn",
      title: "居中对齐",
      onClick: _cache[20] || (_cache[20] = $event => $options.commandHandler('AlignCenter'))
    }, {
      default: _withCtx(() => [_createVNode(_component_IconDocJuzhongduiqi)]),
      _: 1
    }, 8, ["size", "color"]), _createVNode(_component_el_icon, {
      size: $data.toolBtn.size,
      color: $data.toolBtn.color,
      class: "tool-btn",
      title: "右对齐",
      onClick: _cache[21] || (_cache[21] = $event => $options.commandHandler('AlignRight'))
    }, {
      default: _withCtx(() => [_createVNode(_component_IconDocYouduiqi)]),
      _: 1
    }, 8, ["size", "color"]), _createVNode(_component_el_icon, {
      size: $data.toolBtn.size,
      color: $data.toolBtn.color,
      class: "tool-btn",
      title: "左右对齐",
      onClick: _cache[22] || (_cache[22] = $event => $options.commandHandler('AlignDistribute'))
    }, {
      default: _withCtx(() => [_createVNode(_component_IconDocZuoyouduiqi)]),
      _: 1
    }, 8, ["size", "color"]), _hoisted_52, _createVNode(_component_el_icon, {
      size: $data.toolBtn.size,
      color: $data.toolBtn.color,
      class: "tool-btn",
      title: "数字列表",
      onClick: _cache[23] || (_cache[23] = $event => $options.commandHandler('insertorderedlist'))
    }, {
      default: _withCtx(() => [_createVNode(_component_IconDocYouxupailie)]),
      _: 1
    }, 8, ["size", "color"]), _createVNode(_component_el_icon, {
      size: $data.toolBtn.size,
      color: $data.toolBtn.color,
      class: "tool-btn",
      title: "圆点列表",
      onClick: _cache[24] || (_cache[24] = $event => $options.commandHandler('BulletedList'))
    }, {
      default: _withCtx(() => [_createVNode(_component_IconDocWuxupailie)]),
      _: 1
    }, 8, ["size", "color"])]), _hoisted_53])]),
    _: 1
  })]), _createVNode(_component_el_dialog_sec, {
    width: "200px",
    ref: "dialog",
    title: "对齐方式",
    defaultBtn: false,
    "append-to-body": ""
  }, {
    form: _withCtx(() => [_createElementVNode("div", _hoisted_54, [_createElementVNode("div", {
      class: "align-icon",
      onClick: _cache[25] || (_cache[25] = $event => $options.commandHandler('AlignTopLeft'))
    }, _hoisted_56), _createElementVNode("div", {
      class: "align-icon",
      style: {
        "justify-content": "center"
      },
      onClick: _cache[26] || (_cache[26] = $event => $options.commandHandler('AlignTopCenter'))
    }, _hoisted_58), _createElementVNode("div", {
      class: "align-icon",
      style: {
        "justify-content": "flex-end"
      },
      onClick: _cache[27] || (_cache[27] = $event => $options.commandHandler('AlignTopRight'))
    }, _hoisted_60), _createElementVNode("div", {
      class: "align-icon",
      style: {
        "align-items": "center"
      },
      onClick: _cache[28] || (_cache[28] = $event => $options.commandHandler('AlignMiddleLeft'))
    }, _hoisted_62), _createElementVNode("div", {
      class: "align-icon",
      style: {
        "align-items": "center",
        "justify-content": "center"
      },
      onClick: _cache[29] || (_cache[29] = $event => $options.commandHandler('AlignMiddleCenter'))
    }, _hoisted_64), _createElementVNode("div", {
      class: "align-icon",
      style: {
        "align-items": "center",
        "justify-content": "flex-end"
      },
      onClick: _cache[30] || (_cache[30] = $event => $options.commandHandler('AlignMiddleRight'))
    }, _hoisted_66), _createElementVNode("div", {
      class: "align-icon",
      style: {
        "align-items": "flex-end"
      },
      onClick: _cache[31] || (_cache[31] = $event => $options.commandHandler('AlignBottomLeft'))
    }, _hoisted_68), _createElementVNode("div", {
      class: "align-icon",
      style: {
        "align-items": "flex-end",
        "justify-content": "center"
      },
      onClick: _cache[32] || (_cache[32] = $event => $options.commandHandler('AlignBottomCenter'))
    }, _hoisted_70), _createElementVNode("div", {
      class: "align-icon",
      style: {
        "align-items": "flex-end",
        "justify-content": "flex-end"
      },
      onClick: _cache[33] || (_cache[33] = $event => $options.commandHandler('AlignBottomRight'))
    }, _hoisted_72)])]),
    _: 1
  }, 512), _createVNode(_component_el_dialog_sec, {
    ref: "customDataDialog",
    title: "选择关键词",
    "append-to-body": "",
    onOnsubmit: $options.setCustomData,
    onClosed: $options.clearCustomFieldVar,
    style: {
      "width": "350px"
    }
  }, {
    form: _withCtx(() => [_createElementVNode("div", _hoisted_73, [!$data.customFieldCommonItem.isMore ? (_openBlock(), _createBlock(_component_el_radio_group, {
      key: 0,
      modelValue: $data.customFieldChecked,
      "onUpdate:modelValue": _cache[34] || (_cache[34] = $event => $data.customFieldChecked = $event)
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_74, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.customFieldList, (item, index) => {
        return _openBlock(), _createBlock(_component_el_radio, {
          label: item,
          key: 'customfieldList' + item + index
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
          _: 2
        }, 1032, ["label"]);
      }), 128))])]),
      _: 1
    }, 8, ["modelValue"])) : (_openBlock(), _createBlock(_component_el_checkbox_group, {
      key: 1,
      modelValue: $data.customFieldMoreChecked,
      "onUpdate:modelValue": _cache[35] || (_cache[35] = $event => $data.customFieldMoreChecked = $event)
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_75, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.customFieldList, (item, index) => {
        return _openBlock(), _createBlock(_component_el_checkbox, {
          label: item,
          key: 'customfieldList' + item + index
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
          _: 2
        }, 1032, ["label"]);
      }), 128))])]),
      _: 1
    }, 8, ["modelValue"]))])]),
    _: 1
  }, 8, ["onOnsubmit", "onClosed"]), _createVNode(_component_el_dialog_sec, {
    ref: "dateFieldDialog",
    title: "选择日期",
    "append-to-body": "",
    onOnsubmit: $options.setDateData,
    onClosed: $options.clearDateFieldVar,
    style: {
      "width": "300px"
    }
  }, {
    form: _withCtx(() => [_createVNode(_component_el_date_picker, {
      modelValue: $data.dateValue,
      "onUpdate:modelValue": _cache[36] || (_cache[36] = $event => $data.dateValue = $event),
      type: "date",
      placeholder: "选择日期",
      format: $data.dateFormat,
      "value-format": "YYYY-MM-DD",
      style: {
        "width": "100%"
      }
    }, null, 8, ["modelValue", "format"])]),
    _: 1
  }, 8, ["onOnsubmit", "onClosed"])], 64);
}